import React from 'react';
import Header from '../Header/Header';
import Footer from '../../../components/layout/Footer/Footer';
import AnimatedBackground from '../AnimatedBackground/AnimatedBackground';
import { useAuth } from '../../../contexts/AuthContext';
import { useUI } from '../../../contexts/UIContext';
import { useLocation } from 'react-router-dom';

import styled from 'styled-components';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`;

const Main = styled.main`
  flex: 1;
  padding: 2rem 0;
  position: relative;
  z-index: 1;
`;

const Layout = ({ children }) => {
  const { user } = useAuth();
  const { isWorkshopModalOpen } = useUI();
  const location = useLocation();
  
  // Check if current page is login page
  const isLoginPage = location.pathname === '/login' || location.pathname === '/';
  
  return (
    <LayoutContainer>
      <AnimatedBackground isLoginPage={isLoginPage} />
      {user && !isWorkshopModalOpen && <Header />}
      <Main>
        {children}
      </Main>
      <Footer />
    </LayoutContainer>
  );
};

export default Layout;